import React from 'react';
import clsx from 'clsx';

type Props = { step: number; title: string; text: string };

const ApplyStep: React.FC<Props> = ({ step, title, text }) => {
  return (
    <div className="flex w-full gap-[3rem]">
      <div className="flex flex-col items-center">
        <div
          className={clsx(
            'flex items-center justify-center rounded-full bg-bg-primaryMedium',
            'h-7 sm:h-8',
            'w-7 sm:w-8'
          )}
        >
          <span
            className={clsx(
              'font-bold text-text-primary',
              'text-lead1 sm:text-h5'
            )}
          >
            {step}
          </span>
        </div>
        {step !== 4 && (
          <div
            className="my-2 w-[2px] flex-1"
            style={{
              backgroundImage:
                'linear-gradient(#E8E8E8 33%, rgba(255,255,255,0) 0%)',
              backgroundPosition: 'right',
              backgroundSize: '4px 10px',
              backgroundRepeat: 'repeat-y',
            }}
          />
        )}
      </div>
      <div
        className={clsx(
          'flex flex-1 flex-col',
          'gap-2 sm:gap-3',
          'pb-8 lg:pb-5'
        )}
      >
        <span
          className={clsx(
            'font-semibold text-text-primary',
            'text-lead2 sm:text-lead1'
          )}
        >
          {title}
        </span>
        <span
          className={clsx(
            'font-medium text-text-primaryMedium',
            'text-body sm:text-2xl'
          )}
        >
          {text}
        </span>
      </div>
    </div>
  );
};

export { ApplyStep };
